import { useTranslation } from "react-i18next";
import "../../styles/ProductLinksBlock.css";

export default function ProductLinksBlock({ block, onAction }) {
  const { t, i18n } = useTranslation("chat");
  const items = Array.isArray(block?.products) ? block.products : [];

  function formatUAH(price) {
    const n = Number(price || 0);
    const locale = i18n.language?.startsWith("uk") ? "uk-UA" : "en-US";

    const formatted = new Intl.NumberFormat(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(n);

    return `${t("currency_symbol")}${formatted}`;
  }

  function getShortDescription(text, maxLen = 140) {
    if (!text) return "";

    const clean = String(text)
      .replace(/\s+/g, " ")
      .replace(/&nbsp;/g, " ")
      .trim();

    if (!clean) return "";

    const sentences = clean.split(/(?<=[.!?])\s+/).filter(Boolean);

    let result = "";

    for (const s of sentences) {
      const next = result ? `${result} ${s}` : s;
      if (next.length <= maxLen) {
        result = next;
      } else {
        break;
      }
    }

    if (!result) {
      result = clean.slice(0, maxLen).trim();
    }

    result = result.replace(/[.!?]+$/, "");

    if (result.length < clean.length) {
      result += "...";
    }

    return result;
  }

  const uniqItems = [];
  const seen = new Set();

  for (const p of items) {
    const pid = p?.variant_id || p?.id;
    if (!pid) continue;

    const key = String(pid);
    if (seen.has(key)) continue;

    seen.add(key);
    uniqItems.push(p);
  }

  return (
    <div className="tBlock">
      <div className="tBlockTitle">
        {block?.title || t("products_title")}
      </div>

      <ul className="tList">
        {uniqItems.map((p) => {
          const pid = p?.variant_id || p?.id;
          if (!pid) return null;

          const price = Number(p?.price || 0);
          const old = p?.old_price != null ? Number(p.old_price) : null;

          const hasSale =
            old != null &&
            Number.isFinite(old) &&
            old > 0 &&
            Number.isFinite(price) &&
            price > 0 &&
            old > price;

          const productName = p?.name || t("product_unnamed");
          const description = getShortDescription(p?.description_text);

          return (
            <li key={String(pid)} className="tItem">
              <button
                type="button"
                className="tLinkWrap"
                onClick={() =>
                  onAction?.({
                    type: "open_product",
                    product_id: String(pid),
                    product: p,
                  })
                }
                title={productName}
              >
                <span className="tBullet">•</span>

                <span className="tName">{productName}</span>

                {(price > 0 || hasSale) && (
                  <span className="tPriceInline">
                    {" "}
                    (
                    {hasSale ? (
                      <>
                        <span className="tOldPrice">
                          {formatUAH(old)}
                        </span>{" "}
                      </>
                    ) : null}
                    <span className="tPrice">
                      {formatUAH(price)}
                    </span>
                    )
                  </span>
                )}

                {description && (
                  <span className="tDescInline">
                    {" — "}{description}
                  </span>
                )}
              </button>
            </li>
          );
        })}
      </ul>
      {block?.has_more && block?.action ? (
  <button
    type="button"
    className="catalogListBtn"
    onClick={() => onAction?.(block.action)}
  >
    <span className="catalogListBtnLabel">
  {t("show_all")}
</span>

    {block?.total ? (
      <span className="catalogListBtnCount">
        {block.total}
      </span>
    ) : null}

    <span className="catalogListBtnArrow">→</span>
  </button>
) : null}
    </div>
  );
}